module.exports = __webpack_public_path__ + "img/line_c.b56f453b.svg";